// extracted by mini-css-extract-plugin
export var modalFooter = "_mv-0";